export const NUMBER_SET = 'NUMBER_SET'

export const setGlobalNumber = (setting, calltracksClass) => {
  return { type: NUMBER_SET, setting, calltracksClass }
}
